export default "__VITE_ASSET__eTL7O_cW__"